import Div from "@jumbo/shared/Div";
import React from "react";
import { useLocation } from "react-router-dom";

const getPortName = (value) => {
  if (value == null) return "-";
  const text = String(value).trim();
  if (!text) return "-";
  const dashIndex = text.indexOf("-");
  if (dashIndex > 0 && /^\d/.test(text)) {
    return text.slice(dashIndex + 1).trim() || text;
  }
  return text;
};

export default function PrintPackingSlip() {
  const { state } = useLocation();
  const data = state?.data || {};
  const orderNo = data.order_no || "-";
  const portName = getPortName(data.order_port_no_and_name);
  const itemName = data.order_item_name || "-";
  const qty = 1;
  const itemFontSize = Math.max(10 - String(itemName).length * 0.15, 8);

  return (
    <Div
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Div
        sx={{
          width: "188.9764px",
          padding: "6px 10px",
          boxSizing: "border-box",
          backgroundColor: "#fff",
        }}
      >
        <Div sx={{ fontSize: "11px", fontWeight: 700, lineHeight: 1.2 }}>
          {orderNo}
        </Div>
        <Div sx={{ fontSize: "10px", fontWeight: 600, lineHeight: 1.2, mt: 0.3 }}>
          {portName}
        </Div>
        <Div
          sx={{
            fontSize: `${itemFontSize}px`,
            fontWeight: 600,
            lineHeight: 1.15,
            mt: 0.3,
            wordBreak: "break-word",
          }}
        >
          {itemName}
        </Div>
        <Div sx={{ fontSize: "10px", fontWeight: 700, mt: 0.4 }}>Qty: {qty}</Div>
      </Div>
    </Div>
  );
}
